/* global femcare */

femcare.quiz.base = {
    init: function () {
        if (!$('.quiz').length) {
            return;
        }

        /**
         * Creates an instance of the BaseQuiz class.
         * @param {jQuery} $quiz - The jQuery object representing the quiz container.
         */
        function BaseQuiz($quiz) {
            this.id = window.quiz.id;
            this.postUrl = window.quiz.postUrl;
            this.$quiz = $quiz;
            this.$intro = this.$quiz.find('.quiz-intro');
            this.$questionnaire = this.$quiz.find('.questionnaire');
            this.$steps = this.$questionnaire.find('.questionnaire__step');
            this.$result = this.$quiz.find('.quiz-result');
            this.userDataSkipped = false;

            this.initBaseEventHandlers();
            if (this.initDerivedEventHandlers) {
                this.initDerivedEventHandlers();
            }
        }

        /**
         * Initializes the base event handlers for the quiz.
         */
        BaseQuiz.prototype.initBaseEventHandlers = function () {
            const $start = this.$quiz.find('.quiz__start');
            $start.click(() => this.start());

            const $next = this.$questionnaire.find('.questionnaire__next');
            $next.click((e) => this.next(e));

            const $previous = this.$questionnaire.find('.questionnaire__previous');
            $previous.click((e) => this.previous(e));

            const $restart = this.$quiz.find('.quiz__restart');
            $restart.click(() => this.restart());

            const $answers = this.$questionnaire.find('input, select');
            $answers.change(() => $(this).validate());
        };

        /**
         * Resets the flag indicating whether user data collection was skipped.
         */
        BaseQuiz.prototype.resetUserDataSkipped = function () {
            this.userDataSkipped = false;
        };

        /**
         * Starts the quiz, hiding the intro and showing the questionnaire.
         */
        BaseQuiz.prototype.start = function () {
            this.resetUserDataSkipped();
            this.prepareQuestionnaire();
            this.$intro.hide();
            this.$questionnaire.show();
            this.scrollTop();
        };

        /**
         * Switches the view to the specified step.
         * @param {jQuery} $step - The jQuery object representing the step to switch to.
         */
        BaseQuiz.prototype.switchToStep = function ($step) {
            if (this.prepareStep) {
                this.prepareStep($step);
            }

            if ($step.is('.questionnaire__step--user-data')) {
                this.resetUserDataSkipped();
            }

            this.$steps.hide();
            $step.show();
        };

        /**
         * Proceeds to the next step in the quiz.
         * @param {Event} e - The event object.
         */
        BaseQuiz.prototype.next = function (e) {
            const $currentStep = $(e.currentTarget).closest('.questionnaire__step');

            if (this.validateStep($currentStep)) {
                const nextStep = $currentStep.index('.questionnaire__step') + 1;

                if (nextStep < this.$steps.length) {
                    const $nextStep = $(this.$steps[nextStep]);
                    this.switchToStep($nextStep);
                } else {
                    this.finish();
                }
            }
            this.scrollTop();
        };

        /**
         * Returns to the previous step in the quiz.
         * @param {Event} e - The event object.
         */
        BaseQuiz.prototype.previous = function (e) {
            const $currentStep = $(e.currentTarget).closest('.questionnaire__step');
            const previousStep = $currentStep.index('.questionnaire__step') - 1;
            const $previousStep = $(this.$steps[previousStep]);
            this.switchToStep($previousStep);
            this.scrollTop();
        };

        /**
         * Completes the quiz and displays the results.
         */
        BaseQuiz.prototype.finish = function () {
            this.prepareResult();
            this.$questionnaire.hide();
            this.$result.show();

            if (this.postUrl) {
                this.post();
            }

            this.scrollTop();
        };

        /**
         * Restarts the quiz to its initial state.
         */
        BaseQuiz.prototype.restart = function () {
            this.resetUserDataSkipped();
            this.prepareQuestionnaire();
            this.$questionnaire.show();
            this.$result.hide();
            this.scrollTop();
        };

        /**
         * Scrolls the page to the top of the quiz.
         */
        BaseQuiz.prototype.scrollTop = function () {
            const navbarHeight = $('.navigation').height();
            const offset = this.$quiz.offset().top - navbarHeight;
            $('html, body').animate({ scrollTop: offset }, 100);
        };

        /**
         * Validates the current step before moving on.
         * @param {jQuery} $step The jQuery object representing the current step.
         * @returns {boolean} The result of the validation.
         */
        BaseQuiz.prototype.validateStep = function ($step) {
            return $step.validateForm();
        };

        femcare.quiz.BaseQuiz = BaseQuiz;
    }
};
